<template>
  <div>
    <div
      class="fixed md:sticky md:top-[220px] bg-white border-1 border-grey-divider-subdued border-solid rounded-xl p-16 w-full left-0 bottom-80"
    >
      <ParentHasReplied v-if="parentHasReplied" />
      <ParentHasNotReplied v-else />
    </div>
  </div>
</template>

<script lang="ts">
import ParentHasNotReplied from './ParentHasNotReplied.vue';
import ParentHasReplied from './ParentHasReplied.vue';

export default {
  name: 'ReplyContainer',
  components: {
    ParentHasNotReplied,
    ParentHasReplied,
  },
  computed: {
    parentHasReplied(): boolean {
      const applicationDetails = this.$store.getters['applications/applicationDetails'];
      return !!(applicationDetails && applicationDetails.parentLastRepliedAt);
    },
  },
};
</script>
